module.exports = __webpack_public_path__ + "img/logout.c59bc186.svg";